<div class="form" [formGroup]="form()">
  <div class="location-title">
    {{ "withdrawal.CODEOffice.location.label" | translate }}
    <iw-tooltip [maxWidth]="257" position="bc">
      <ng-template #tooltipContentTpl>
        <div class="tooltip-message">
          {{ "withdrawal.CODEOffice.title.tooltip1" | translate }}
          <a
            class="link"
            target="_blank"
            [href]="supportLink"
            rel="noopener noreferrer"
          >
            {{ "withdrawal.CODEOffice.title.tooltip2" | translate }}
          </a>
        </div>
      </ng-template>
    </iw-tooltip>
  </div>
  <div class="value">
    <p class="value-title">{{ me()?.location?.symbolicName }}</p>
  </div>
</div>
